import type { RuntimeEvent } from "./events";

type EventListener = (event: RuntimeEvent) => void;

export interface RuntimeBus {
  publish: (event: RuntimeEvent) => void;
  subscribe: (listener: EventListener) => () => void;
}

export function createRuntimeBus(): RuntimeBus {
  const listeners = new Set<EventListener>();

  return {
    publish(event) {
      listeners.forEach((listener) => listener(event));
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
